import React, {
  useCallback,
} from 'react';
import {
  PCCProgram,
} from 'dtos/pCCProgram';
import {
  PCCProgramSelectionRow,
} from 'pages/Dashboard/pages/Encounters/pages/VisitNote/components/PCC/PCCPopoverProgramRow';
import {
  PCC_PROGRAMS,
} from 'pages/Dashboard/pages/Encounters/pages/VisitNote/components/PCC/utils';

type Props = {
  programs: PCCProgram[];
  selectedPrograms: PCCProgram[];
  isEnrolling: boolean;
  onChange: (programs: PCCProgram[]) => void;
};

export default function EnrollProgramsStep({
  programs,
  selectedPrograms,
  isEnrolling,
  onChange,
}: Props) {
  const programOptions = PCC_PROGRAMS.filter(
    (program) => programs.includes(program.type),
  );

  const handleToggle = useCallback((programType: PCCProgram, checked: boolean) => {
    onChange(checked
      ? [ ...selectedPrograms, programType ]
      : selectedPrograms.filter((selectedProgram) => selectedProgram !== programType));
  }, [onChange, selectedPrograms]);

  return (
    <div className="flex flex-col gap-4 text-xs flex-1">
      <div className="flex flex-col gap-1.5">
        {programOptions.map((program) => (
          <PCCProgramSelectionRow
            key={program.key}
            checkboxId={`pcc-enroll-${program.key}`}
            program={program}
            canEnroll
            isEnrolling={isEnrolling}
            isSelected={selectedPrograms.includes(program.type)}
            onToggle={(checked) => { handleToggle(program.type, checked); }}
          />
        ))}
      </div>
    </div>
  );
}
